<template>
  <div class="commonInfor">
    <div class="null" v-show="isContent">
      <div class="nullInforIcon">
        <img src="../assets/images/nullInforIcon.png" alt="" />
      </div>
      <div class="tipsWord">
        您还没有添加常用信息，赶快去 <span class="secondLine"> 添加吧！</span>
      </div>
      <div class="dibu" @click="addInfor">
        <div class="addInfor">
          <div class="content">
            <div class="jiaIcon">
              <img src="../assets/images/jiahao.png" alt="" />
            </div>
            <div class="word">添加常用信息</div>
          </div>
        </div>
      </div>
    </div>
    <div class="hasContent" v-show="hasContent">
      <div class="allList">
        <div class="everyList" v-for="(item, index) in inforList" :key="index">
          <div class="contentList" @click="lookInfor(item.id)">
            <div class="content">
              <div class="contentName">{{ item.title }}</div>
              <div class="addrName">{{ item.content }}</div>
            </div>
            <div class="youjian">
              <img src="../assets/images/youjian.png" alt="" />
            </div>
          </div>
          <div class="del" @click="delInfor(item.id)">
            <div class="indel">
              <div class="delIcon">
                <img src="../assets/images/delIcon.png" alt="" />
              </div>
              <div class="word">删除</div>
            </div>
          </div>
        </div>
      </div>

      <div class="dibuBtn" @click="goAddInfor">
        <button>添加常用信息</button>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import Vue from "vue";
import qs from "qs";
import { Dialog } from "vant";
import { Field } from "vant";
import { Toast } from "vant";

Vue.use(Toast);

Vue.use(Field);

export default {
  mounted() {

    this.getInforList();
    // this.getToken();
  },

  data() {
    return {
      isContent: true,
      hasContent: false,
      inforList: [],
    };
  },
  methods: {
    addInfor() {
      this.$router.push("/addinfor");
    },
    goAddInfor() {
      this.$router.push("/addinfor");
    },
    lookInfor(id) {
      this.$router.push({
        name: "ChangeInfor",
        query: {
          id,
        },
      });
    },
    delInfor(id) {
      Dialog.confirm({
        message: "是否确认删除",
      })
        .then(() => {
          let params = qs.stringify({
            id,
          });
          this.$axios
            .post("cityuserinfo/commonly/info/delUserCommonlyInfo", params)
            .then((res) => {
              if (res.data.result !== 1) {
                Dialog.alert({
                  message: res.data.reason,
                }).then(() => {
                  this.getInforList();
                });
                return;
              }
              if (res.data.result === 1) {
                Dialog.alert({
                  message: res.data.reason,
                }).then(() => {
                  this.getInforList();
                });

                return;
              }
            })
            .catch((err) => {
              console.error(err);
              Dialog.alert({
                message: "接口调用失败",
              }).then(() => {
                this.getInforList();
              });
              return;
            });
        })
        .catch(() => {
          // on cancel
        });
    },

    getInforList() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      this.inforList = [];
      this.$axios
        .post("cityuserinfo/user/commonly/info/getPageList")
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
             Toast.clear()
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
             Toast.clear()
            console.log(res);

            if (res.data.rows.length == 0) {
              (this.isContent = true), (this.hasContent = false);
            }
            if (res.data.rows.length !== 0) {
              (this.isContent = false), (this.hasContent = true);
              res.data.rows.forEach((item) => {
                this.inforList.push(item);
              });
            }
          }
        })
        .catch((err) => {
           Toast.clear()
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.allList {
  margin-bottom: 6.25rem;
}
.null {
  background: #eef4f6;
  min-height: 100vh;
  padding: 8.625rem 8.125rem;
}
.nullInforIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 16.5rem;
    height: 15.5rem;
  }
}
.tipsWord {
  color: #19212a;
  font-size: 2.125rem;
  margin-top: 3.75rem;
  .secondLine {
    display: block;
    text-align: center;
  }
}
.dibu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4.375rem;

  .addInfor {
    width: 23.75rem;
    height: 5.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #338989;
    border-radius: 2.75rem;
    .content {
      display: flex;
      align-items: center;
      .jiaIcon img {
        width: 1.75rem;
      }
      .word {
        color: #338989;
        font-size: 2rem;
        line-height: 3rem;
        margin-left: 0.625rem;
      }
    }
  }
}
.hasContent {
  background: #eef4f6;
  min-height: 100vh;
  padding: 2.5rem 0.875rem;

  .everyList {
    display: flex;
    overflow: auto;

    .del {
      flex-shrink: 0;
      width: 8rem;
      height: 10rem;
      background-color: #fff;
      margin-left: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 1.5rem;
      .delIcon {
        display: flex;
        justify-content: center;
        img {
          width: 2.25rem;
          height: 2.5rem;
        }
      }
      .word {
        margin-top: 0.625rem;
        color: #555555;
        font-size: 1.75rem;
        line-height: 2.5rem;
      }
    }
    .contentList {
      flex-shrink: 0;
      margin: 0 1rem 1.25rem 1rem;
      width: 42.875rem;
      height: 10rem;
      background-color: #fff;
      padding: 1.875rem 2.125rem;
      border-radius: 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .content {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .contentName {
        color: #19212a;
        font-size: 2rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .addrName {
        color: #878787;
        font-size: 1.75rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .youjian {
        img {
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }
  }

  .dibuBtn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.875rem;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 0 2rem 2rem 2rem;
    background: #eef4f6;
    z-index: 100;

    button {
      width: 100%;
      height: 5.5rem;
      background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
      border: none;
      color: #ffffff;
      font-size: 2rem;
      border-radius: 2.75rem;
      line-height: 5.5rem;
    }
  }
}
</style>